module.exports = __webpack_public_path__ + "static/media/data_billboard.526d5689.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/data_billboard.png
// module id = 187
// module chunks = 0